import { faChartLine, faScrewdriverWrench, faServer, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function OpcionesInicioInv() {
    return (
        <div className="w-full h-[100vh] flex items-center justify-center bg-[#0E7FA0]">
            <div className="flex flex-col items-center h-full p-5 rounded-xl justify-center">
                <div className="items-center mt-2">
                    <FontAwesomeIcon icon={faUserPlus} className="fa-user-plus text-[#0E7FA0] text-4xl rounded-full bg-white p-10 w-10 h-10" />
                </div>
                <div className="px-5 pt-2 text-white w-full">
                    <h1 className="font-bold text-xl">Formulario</h1>
                    <p className="text-sm">Registrar a nuevos usuarios del servicio</p>
                    <div className="flex justify-center">
                        <Link to="/Beneficiario_DatosTrabajador" className="mt-3">
                            <button className="rounded-full bg-[#FBC022] p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px]">Iniciar Registro</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpcionesInicioInv;